
import DateConflict, {IDateConflict} from "@/types/clients/esquire/data/booking/date-conflict";
import PricePerNightRate, {
  IPricePerNightRate
} from "@/types/clients/esquire/data/booking/price-per-night-rate";
import OptionData, {IOptionData} from "@/types/clients/esquire/data/general/contract-data/option";

export interface IBookingContract {
  reference: string;
  is_possible: boolean;
  messages?: string[];
  status?: string;
  is_valid_status?: boolean;
  date_conflict: IDateConflict[];
  availability?: number;
  rate?: IPricePerNightRate;
  recurring_services: IOptionData[];
}
export default class BookingContract {
  public reference: string;
  public isPossible: boolean;
  public messages?: string[];
  public status?: string;
  public isValidStatus?: boolean;
  public dateConflict: DateConflict[];
  public availability?: number;
  public pricing?: PricePerNightRate|null;
  public recurringServices: OptionData[];

  constructor(data: IBookingContract) {
    this.reference = data.reference;
    this.isPossible = data.is_possible;
    this.messages = data.messages;
    this.status = data.status;
    this.isValidStatus = data.is_valid_status;
    this.dateConflict = Array.isArray(data.date_conflict)
      ? data.date_conflict.map(dc => new DateConflict(dc))
      : [];
    this.availability = data.availability;
    this.pricing = data.rate ? new PricePerNightRate(data.rate) : null;
    this.recurringServices = data.recurring_services ? data.recurring_services.map(o => new OptionData(o)) : [];
  }

  toJson(): Record<string, unknown> {
    const json: Record<string, unknown> = {};
    if (this.reference !== null) json.reference = this.reference;
    if (this.isPossible !== null) json.is_possible = this.isPossible;
    if (this.messages !== null) json.messages = this.messages;
    if (this.status !== null) json.status = this.status;
    if (this.isValidStatus !== null) json.is_valid_status = this.isValidStatus;
    if (this.dateConflict !== null) json.date_conflict = this.dateConflict.map((c: DateConflict) => c.toJson());
    if (this.availability !== null) json.availability = this.availability;
    if (this.pricing !== null) json.pricing = this.pricing?.toJson();
    if (this.recurringServices !== null) json.recurring_services = this.recurringServices.map((o: OptionData) => o.toDTO());

    return json;
  }
}
